﻿(() => {
  if (customElements.get('customer-stories-slider')) return;
  customElements.define('customer-stories-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.customer-stories__grid');
      this.controls = this.querySelector('.customer-stories__controls');
      this.pagination = this.querySelector('.customer-stories__pagination');
      const avatarColors = ['#244459', '#765343', '#526b4c', '#765674', '#386b70', '#805349'];
      this.querySelectorAll('.customer-stories__avatar--placeholder').forEach(avatar => {
        if (!avatar.style.getPropertyValue('--avatar-background')) {
          avatar.style.setProperty('--avatar-background', avatarColors[Math.floor(Math.random() * avatarColors.length)]);
        }
      });
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-direction], [data-page]');
        const card = this.track.firstElementChild;
        if (!button || !card) return;
        const style = getComputedStyle(this.track);
        const sign = style.direction === 'rtl' ? -1 : 1;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        if (button.hasAttribute('data-page')) {
          this.track.scrollTo({ left: this.pages[Number(button.dataset.page)] * sign, behavior });
        } else {
          const step = card.getBoundingClientRect().width + (parseFloat(style.columnGap) || 0);
          this.track.scrollBy({ left: Number(button.dataset.direction) * step * sign, behavior });
        }
      }, { signal });
      this.addEventListener('shopify:block:select', event => {
        event.target.closest('.customer-stories__card')?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
      }, { signal });
      this.track.addEventListener('scroll', () => this.update(), { passive: true, signal });
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    update() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const position = Math.abs(this.track.scrollLeft);
      this.controls.hidden = this.pagination.hidden = max <= 2;
      this.controls.querySelectorAll('[data-direction]').forEach(button => {
        button.disabled = Number(button.dataset.direction) < 0 ? position <= 2 : position >= max - 2;
      });
      const card = this.track.firstElementChild;
      if (!card) return;
      const step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
      if (step <= 0) return;
      this.pages = [0];
      for (let offset = step; offset < max - 2; offset += step) this.pages.push(offset);
      if (max > 2) this.pages.push(max);
      if (this.pagination.children.length !== this.pages.length) {
        this.pagination.replaceChildren(...this.pages.map((_, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'customer-stories__dot';
          button.dataset.page = index;
          button.setAttribute('aria-label', `Go to review slide ${index + 1}`);
          button.setAttribute('aria-controls', this.track.id);
          return button;
        }));
      }
      const active = this.pages.reduce((best, offset, index) => Math.abs(offset - position) < Math.abs(this.pages[best] - position) ? index : best, 0);
      [...this.pagination.children].forEach((button, index) => button.setAttribute('aria-current', String(index === active)));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
})();
